import React, { useState } from 'react';
import cn from 'classnames';
import moment from 'moment';
import { Row, Col, Alert, Button, Badge, Modal, Form, InputNumber } from 'antd';
import { Link } from 'react-router';
import { formatNumber, formatRating, formatLongThaiDuration } from 'utils/formatting';
import classes from '../styles/class/ClassInfo.module.scss';
import { updateClassById } from 'data/class';
import { formItemLayout, fullFormLayout } from 'constants/layout';
import ComFeeModal from './ComFeeModal';
const FormItem = Form.Item;

const ClassHeader = ({ classroom, Tabs, onOpenCloseModal }) => {
  const registerDate = moment(classroom.createdAt).format('DD/MM/YYYY');
  return (
    <div className={cn('content-header', classes.headerContainer)}>
      {classroom.status === 'approved' && <Alert message="Approved class" type="success" description={' '} />}
      {classroom.status === 'rejected' && <Alert message="Rejected class" type="error" description={<div dangerouslySetInnerHTML={{ __html: classroom.rejectMessage }} />} />}
      {classroom.status === 'closed' && <Alert message="Closed class" type="info" description={' '} />}
      {classroom.status === 'pending' && <Alert message="Pending class" type="warning" description={' '} />}
      <Row className={classes.headerContent}>
        <Col xs={24}>
          <div className="pull-right">
            <Button type="danger" onClick={onOpenCloseModal}>
              Close
            </Button>
          </div>
          <div className="header-title">
            <span className="bold">Class: </span>
            {classroom.name}
            {classroom.classType === 'multiple' && <span className={'subtitle'}> (เรียน {classroom.studiedCount} ครั้ง)</span>}
            {classroom.classType === 'flexible' && (
              <Badge className={'noti-container'} count={classroom.requestedCount} showZero>
                {' '}
              </Badge>
            )}
          </div>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col xs={3}>
          <div className={classes.imageContainer}>
            <img className={cn(classes.profileImage)} src={classroom.coverImage} />
          </div>
        </Col>
        <Col xs={9}>
          <div>
            <span className="bold">Class No.:</span> {classroom.classCode}
          </div>
          <div>
            <span className="bold">Teacher:</span> <Link to={`/teacher/${classroom.owner._id}`}>{classroom.owner.displayName}</Link>
          </div>
          <div>
            <span className="bold">Class Type: </span>

            {classroom.classType === 'single' && <span>เรียนครั้งเดียวจบ</span>}
            {classroom.classType === 'multiple' && <span>เรียนหลายครั้ง</span>}
            {classroom.classType === 'timetable' && <span>ผู้เรียนเลือกวันได้</span>}
          </div>
          <div>
            <span className="bold">Create Date: </span>
            {registerDate}
          </div>
        </Col>

        <Col xs={9}>
          <div className={classes.headerInfoBox}>
            <div className={cn(classes.topLeft, classes.box)}>
              <div className="bold">Completion</div>
              {formatNumber(classroom.finishedCourseCount, '0,0')}
            </div>
            <div className={cn(classes.topRight, classes.box)}>
              <div className="bold">Followers</div>
              {formatNumber(classroom.followerCount, '0,0')}
            </div>
            <div className={cn(classes.bottomLeft, classes.box)}>
              <div className="bold">Students</div>
              {formatNumber(classroom.graduatedStudentCount, '0,0')}
            </div>
            <div className={cn(classes.bottomRight, classes.box)}>
              <div className="bold">Reviews</div>
              {formatNumber(classroom.reviewCount, '0,0')}
            </div>
          </div>
        </Col>
      </Row>
      {classroom.remark && (
        <Row>
          <Col xs={24}>
            <span className="bold"> Remark: </span>
            <span className="remark-text">{classroom.remark}</span>
          </Col>
        </Row>
      )}
      {Tabs}
    </div>
  );
};

export default Form.create()(ClassHeader);
